const removeInlineStyles = (input: string) => {
  const matches = Array.from(input.matchAll(/<[^>]+(style="[^>]+")/g));
  let result = input;
  matches.forEach((match) => {
    result = result.replace(match[1], '');
  });
  return result;
};

export default removeInlineStyles;
